import fetch from 'auth/FetchInterceptor'


const AppService = {}

AppService.getVendorCredits = function (data) {
  return fetch({
    url: `vendorCredits`,
    method: 'post',
    headers: {'Accept': 'application/json'},
    data: data
  })
}

AppService.setPost = function (data) {
  return fetch({
    url: '/posts',
    method: 'post',
    data: data
  })
}

AppService.vendorList = function (data) {
  return fetch({
    url: '/api/vendorList',
    method: '',
    data: data
  })
}

export default AppService